import './Message.css';
import TicketInfo from '../TicketInfo/TicketInfo';
import { Typography, Flex } from 'antd';
import { PaperClipOutlined } from '@ant-design/icons';

const Message = ({ text, time, isUser, isLoading = false, ticket = null, attachments = [] }) => {
  return (
    <div className={`message ${isUser ? 'message--user' : 'message--ai'}`}>
      {!isUser && <img src="/avatar.png" alt="AI Avatar" className={`message__avatar ${isUser ? 'message__avatar--user' : 'message__avatar--ai'}`} />}
      <div className="message__content">
        <div className="message__text">
          {attachments && attachments.length > 0 && !isLoading && (
            <div className="message__attachments">
              {attachments.map((file, index) => (
                <div key={file.uid || index} className="message__attachment-item">
                  <Flex gap={8} align='center'>
                    <PaperClipOutlined style={{ fontSize: 16, color: '#4D525B' }} />
                    <Typography.Text style={{ fontSize: 14, color: '#4D525B' }}>
                      {file.name}
                    </Typography.Text>
                  </Flex>
                </div>
              ))}
            </div>
          )}
          <div className="message__text-content">
            {isLoading ? (
              <div className="loading-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
            ) : ticket ? (
              <TicketInfo ticket={ticket} />
            ) : (
              text
            )}
          </div>
        </div>
        <div className="message__time">{time}</div>
      </div>
      {isUser && <img src="/user_fill.png" alt="User Avatar" className={`message__avatar ${isUser ? 'message__avatar--user' : 'message__avatar--ai'}`} />}
    </div>
  );
};

export default Message;